import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  children: React.ReactNode;
  className?: string;
  width?: number;
}

export const Section: React.SFC<IProps> = props => (
  <Container className={props.className}>
    <Inner style={props.width ? { maxWidth: props.width } : {}}>
      {props.children}
    </Inner>
  </Container>
);

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const Inner = styled.div`
  padding: 10px;
  max-width: 1300px;
  width: 100%;
  flex: 1;
`;

export default Section;



// WEBPACK FOOTER //
// ./src/wrappers/Section/Section.tsx